import { render } from "./NonFood.vue?vue&type=template&id=231475d3"
import script from "./NonFood.vue?vue&type=script&lang=js"
export * from "./NonFood.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/themes/default/resources/app/vue/components/AdvancedSearch/NonFood.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "231475d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('231475d3', __exports__)) {
    api.reload('231475d3', __exports__)
  }
  
  module.hot.accept("./NonFood.vue?vue&type=template&id=231475d3", () => {
    api.rerender('231475d3', render)
  })

}


export default __exports__